<div class="make-responsive-entitiesList">
    <div [class]="selectedCategory === widget?.category ? 'example-card cursor bg-white-card p-0 uni-mat-card-selected' : 'example-card cursor bg-white-card p-0 uni-mat-card'" *ngFor="let widget of entityCategories">
        <div class="p-0" (click)="handleClick(widget)" (dblclick)="onDoubleClick(widget)">
            <div class="entity-widget-box">
                <div [class]="selectedCategory === widget?.category ? 'text-center widget-left uni-subcard-bg-selected' : 'text-center widget-left uni-subcard-bg'">
                    <span class="justify-content-center left-value">{{(widget?.entityCount || widget?.entityCount === 0) ? widget?.entityCount :  '-'}}</span>
                    <div class="d-flex gap-2">
                        <div><img [src]="widget?.icon" /></div>
                        <div class="category-text">{{widget?.category?.toUpperCase()}}</div>
                    </div>
                </div>
                <div class="p-2">
                    <div>
                        <div class="widget-value uni-card-widget-value" [title]="widget?.totalDistance"><img
                                src="../../../../assets/images/directions_entities.svg" />{{(widget?.totalDistance || widget?.totalDistance === 0) ? widget?.totalDistanceTrimmed : '-'}}
                        </div>
                        <div class="widget-label uni-card-widget-label">{{ widget?.distanceLabel }}</div>
                    </div>
                    <div>
                        <div class="widget-value uni-card-widget-value"  [title]="widget?.totalEngineHours"><img
                                src="../../../../assets/images/schedule-entities.svg" />{{(widget?.totalEngineHours || widget?.totalEngineHours === 0) ? widget?.totalEnginehoursTrimmed : '-'}}
                        </div>
                        <div class="widget-label uni-card-widget-label">{{ widget?.operatingHoursLabel }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>